import { Outlet, useNavigate } from "react-router-dom";
import './../../assets/styles/fintech.css'
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import Settings from "../../components/logisticsTwo/Settings";
import Header from "../../components/logisticsTwo/Header";
import Sidebar from "../../components/logisticsTwo/Sidebar";
import Footer from "../../components/logisticsTwo/Footer";
import { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import ThemeProvider from "../../hooks/themeProvider";


const LogisticsLayoutTwo = () => {
	let navigate = useNavigate()
	const dispatch = useAppDispatch()
	const [color, setColor] = useState('universal')
	const handleSettigns = () => {
		dispatch(settings.set({ visible: !visible }))
	}
	const { height, width } = useWindowDimensions();
	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar,theme } = result
	
	useEffect(() => {
		dispatch(settings.set({
			theme: 'universal',
		}))
	}, [])
	
	return (
		<>
			<ThemeProvider>
				{width && width < 720 ?
					<>
						<Outlet />
					</>
					:
					<div className="leading-normal tracking-normal" id="main-body">
						<div className="flex flex-col w-full sm:hide max-h-screen h-screen bg-slate-200">
							{visible ? <Settings /> : <></>}
							<Header />
							<div className="w-full flex flex-row bg-primary">
								<Sidebar />

								<div className={`${sidebar ? `ml-64` : `ml-24 z-0 `} w-full overflow-auto mt-20 bg-slate-200 dark:bg-slate-300`}>

									<Outlet />

								</div>
								<div className="fixed bottom-0 z-[1000] w-full bg-slate-50">
									{footer ? <Footer /> : ""}
								</div>
							</div>
						</div>
					</div>
				}
			</ThemeProvider>
		</>
	)
}
export default LogisticsLayoutTwo;